'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getClassReg = require('./getClassReg');

var _getClassReg2 = _interopRequireDefault(_getClassReg);

var _hasClass = require('./hasClass');

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeClass = function removeClass(classes, name) {
    if (classes && (0, _hasClass2.default)(classes, name)) {
        classes = classes.replace((0, _getClassReg2.default)(name), ' ').replace(/(^\s+)|\s+$/g, '');
        if ((0, _hasClass2.default)(classes, name)) {
            // in case of multiple adjacent
            classes = removeClass(classes, name);
        }
    }
    return classes;
};

exports.default = removeClass;
module.exports = exports['default'];